import {Typography} from "antd";
import React from "react";

export const Description = (props: { value: string }) => {
    return (
        <Typography style={{fontSize: 12, color: '#aaaaaa'}}>{props.value}</Typography>
    )
}